<template>
    <div>
        <nav-bar/>
        <b-container
            fluid
            style="background: #f7f7fc"
            class="py-4 strata-plan-details"
        >
            <div style="text-align: right; margin-right: 35px; margin-left: 15px" class="print-icons">
                <a v-if="workOrder" @click="handleQuotePdfDownloadClicked">
                    <b-button
                        class="btn btn-primary"
                        style="border-radius: 5px; padding: 5px 15px"
                        variant="primary"
                    >
                        <i class="fas fa-print"></i>
                    </b-button>
                </a>

                <a
                    v-if="!workOrder"
                    @click="handleQuotePdfDownloadClicked"
                    target="_blank"
                >
                    <b-button
                        class="btn btn-primary"
                        style="border-radius: 5px; padding: 5px 15px"
                        variant="primary"
                    >
                        <i class="fas fa-print"></i>
                    </b-button>
                </a>


                <a
                    v-if="!workOrder"
                    @click="handleInvoicePdfDownloadClicked"
                    target="_blank"
                >
                    <b-button
                        class="btn btn-primary"
                        style="border-radius: 5px; padding: 5px 15px"
                        variant="primary"
                    >
                        Generate Invoice
                    </b-button>
                </a>

                <b-button
                    v-if="
            $store.state.authenticatedUserData.user.id === quote.manager.id &&
            !workOrder
          "
                    class="btn btn-primary"
                    style="border-radius: 5px; padding: 5px 15px;"
                    variant="primary"
                    :to="{
            name: 'manager-quote-edit',
            params: { id: $route.params.id, step: 1 },
          }"
                >
                    <i class="fas fa-edit"></i>
                </b-button>

                <b-button
                    v-if="
            $store.state.authenticatedUserData.user.id === quote.manager.id &&
            workOrder
          "
                    class="btn btn-primary"
                    style="border-radius: 5px; padding: 5px 15px;"
                    variant="primary"
                    :to="{
            name: 'manager-workorder-edit',
            params: { id: $route.params.id, step: 1 },
          }"
                >
                    <i class="fas fa-edit"></i>
                </b-button>

                <b-button
                    v-if="$store.state.authenticatedUserData.user.id === quote.manager.id"
                    class="btn btn-primary"
                    style="border-radius: 5px; padding: 5px 15px;"
                    variant="primary"
                >
                    <i class="fas fa-archive"></i>
                </b-button>
            </div>

            <b-row>
                <b-col
                    cols="12"
                    xl="8"
                    lg="7"
                    md="12"
                    sm="12"
                    class="mt-3 pl-lg-5 px-md-5"
                >
                    <div class="section-first p-5">
                        <h3>JOB ID: {{ quote.organization_id }}</h3>
                        <div v-if="workOrder">

                            <b-button size="sm" class="btn px-3 py-1 primary-bg-slight primary rounded-pill"
                                      v-if="quote.status_parsed == 'open'">
                                Open
                            </b-button>
                            <b-button size="sm" class="btn px-3 py-1 primary-bg-slight primary rounded-pill"
                                v-if="quote.status_parsed == 'active'">
                                Active
                            </b-button>
                            <b-button size="sm" class="btn px-3 py-1 primary-bg-slight primary rounded-pill"
                                v-if="quote.status_parsed == 'pending-approval'">
                                Pending Approval
                            </b-button>
                            <b-button size="sm" class="btn px-3 py-1 primary-bg-slight primary rounded-pill"
                                v-if="quote.status_parsed == 'due'">Due Soon{{ "(" + subtractedDate + " Days Left)" }}
                            </b-button>
                            <b-button size="sm" class="btn px-3 py-1 primary-bg-slight primary rounded-pill"
                                v-if="quote.status_parsed == 'over-due'">
                                Overdue {{ "(" + subtractedDate + " Days Passed)" }}
                            </b-button>
                            <b-button size="sm" class="btn px-3 py-1 primary-bg-slight primary rounded-pill"
                                v-if="quote.status_parsed == 'draft'"
                            >Draft</b-button>

                        </div>
                        <div v-if="quote.is_work_order">
                            <b-button
                                v-if="quote.priority == 'high'"
                                variant="danger"
                                class="btn-high ml-2"
                            >High Priority
                            </b-button
                            >
                        </div>

                        <div v-else class="mb-3">
                            <b-button
                                v-if="quote.is_private"
                                variant="success"
                                class="btn-public px-3"
                                style="padding: 0px"
                            >Private
                            </b-button
                            >
                            <b-button
                                v-else
                                variant="success"
                                class="btn-public px-3"
                                style="padding: 0px"
                            >Public
                            </b-button
                            >
                            <b-button
                                v-if="quote.priority == 'high'"
                                variant="danger"
                                class="px-3 btn-high ml-2"
                                style="padding: 0px"
                            >High Priority
                            </b-button
                            >
                        </div>

                        <div class="job-detail">
                            <ul>
                                <li><span class="title">Job Title: </span> <span class="sub-title">{{
                                        quote.job_title
                                    }}</span></li>
                                <li><span class="title">Strata Plan ID: </span> <span
                                    class="sub-title">{{ quote.strata_plan.strata_plan_number }}</span></li>
                                <li><span class="title">Manager: </span> <span
                                    class="sub-title">{{ quote.manager.full_name }}</span></li>
                                <li class="d-flex">
                                    <span class="title">Trade Type: </span>
                                    <span class="sub-title">
                            <button
                                v-for="category in quote.categories"
                                :key="'cat-' + category.id"
                                type="button"
                                class="btn mr-2">
                                <i class="fas fa-tag mr-2"></i>{{ category.name }}
                            </button>
                        </span>
                                </li>
                            </ul>


                        </div>

                        <hr class="my-3">

                        <div class="section-description">
                            <h4 style="font-size: 20px;">
                                Quote Description
                            </h4>

                            <div class="content">
                                <p
                                    v-html="quote.description"
                                    style="font-size: 14px; color: 4f4f4f; line-height: 24px"
                                ></p>

                                <!-- <p style="font-size: 12px; float: right;">
                                  - Created By: {{ quote.creating_user.full_name }}</p
                                > -->
                            </div>
                        </div>
                    </div>

                    <div
                        class="work-session mt-4 pt-4 pb-5 red"
                        style="
              background-color: #ffffff;
              box-shadow: 1px 3px 10px rgba(233, 239, 244, 0.81);">
                        <b-tabs
                            content-class="mt-3"
                            class="manager-quote-tab ml-4"
                            v-if="!workOrder"
                        >
                            <b-tab
                                active
                                @click="getInvitedContractors"
                            >
                                <template #title>
                                    <span class="tab-icon"><i class="fas fa-users"></i></span>
                                    <span class="tab-icon-title">INVITED CONTRACTORS</span> {{
                                        counts.invited_contractors
                                            ? `[${counts.invited_contractors}]`
                                            : '[0]'
                                    }}
                                </template>
                                <b-table
                                    responsive
                                    striped
                                    hover
                                    :items="invitedContractorsItems"
                                    :fields="invitedContractorsItemsFields"
                                    show-empty
                                >
                                    <template v-slot:cell(sent)="row">
                                        <!-- <button
                                          type="button"
                                          class="btn btn-primary ml-2"
                                          style="
                                            border-radius: 5px;
                                            padding: 5px 15px;
                                            font-size: 12px;
                                          "
                                          @click="resendInvitation(row.item.pivot)"
                                          v-show="
                                            quoteAwarded == false &&
                                            quote.status_parsed != 'completed'
                                          "
                                        >
                                          Resend
                                        </button> -->

                                        <button type="button" class="btn btn-primary"
                                                style="border-radius: 5px; padding: 5px 15px; font-size: 12px;"
                                                href="#!" @click="resendInvitation(row.item.pivot)"
                                                v-show="
                        quoteAwarded == false &&
                        quote.status_parsed != 'completed'
                      ">Resend
                                        </button>

                                        <button href="#!" class="btn btn-primary"
                                                style="border-radius: 5px; padding: 5px 15px; font-size: 12px;"
                                                @click="resendInvitation(row.item.pivot)"
                                                v-show="
                        quoteAwarded == true ||
                        quote.status_parsed == 'completed'
                      "
                                                :disabled="true">Resend
                                        </button>

                                        <!-- <button
                                          type="button"
                                          class="btn btn-primary ml-2"
                                          style="
                                            border-radius: 5px;
                                            padding: 5px 15px;
                                            font-size: 12px;
                                          "
                                          @click="resendInvitation(row.item.pivot)"
                                          v-show="
                                            quoteAwarded == true ||
                                            quote.status_parsed == 'completed'
                                          "
                                          :disabled="true"
                                        >
                                          Resend
                                        </button> -->
                                    </template>

                                    <template v-slot:cell(compliant)="row">
                                        <i
                                            v-if="row.item.compliant"
                                            class="fas fa-check-circle"
                                            style="font-size: 20px; color: #5F2EEA;"
                                        ></i>
                                        <i
                                            v-else
                                            class="fas fa-times-circle"
                                            style="font-size: 20px; color: rgb(237, 46, 126)"
                                        ></i>
                                    </template>

                                    <template v-slot:cell(message)="row">
                                        <i
                                            class="fas fa-comment-alt"
                                            style="font-size: 24px; color: #5F2EEA;"
                                            @click="
                        openChat(
                          row.item.pivot.id,
                          row.item.pivot.receiving_business,
                          row.item.business,
                          'Invited Contractor'
                        )
                      "
                                        ></i>
                                        <span class="msg-count">{{ row.item.unread_count }}</span>
                                    </template>
                                    <template #empty class="text-center">
                                        No Data Found
                                    </template>
                                </b-table>
                            </b-tab>

                            <b-tab
                                @click="getExpressionOfInterests"
                            >
                                <template #title>
                                    <span class="tab-icon"><i class="fas fa-smile-beam"></i></span>
                                    <span class="tab-icon-title">EXPRESSIONS OF INTEREST</span>{{
                                        counts.expression_of_interest
                                            ? `[${counts.expression_of_interest}]`
                                            : '[0]'
                                    }}
                                </template>
                                <b-table
                                    responsive
                                    striped
                                    hover
                                    :items="expressionOfInterest"
                                    :fields="expressionOfInterestFields"
                                    show-empty
                                >
                                    <template v-slot:cell(action)="row">
                                        <button
                                            type="button"
                                            class="btn btn-primary ml-2"
                                            style="border-radius: 5px; padding: 5px 20px"
                                            @click="
                        confirmRespondExpressOfInterest(
                          'accept',
                          row.item.pivot
                        )
                      "
                                            v-show="
                        row.item.pivot.status == 'express_interest_requested'
                      "
                                        >
                                            Accept
                                        </button>
                                        <button
                                            type="submit"
                                            class="btn btn-outline-primary ml-2"
                                            style="border-radius: 5px; padding: 5px 20px"
                                            @click="
                        confirmRespondExpressOfInterest(
                          'reject',
                          row.item.pivot
                        )
                      "
                                            v-show="
                        row.item.pivot.status == 'express_interest_requested'
                      "
                                        >
                                            Decline
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-outline-primary ml-2"
                                            style="border-radius: 5px; padding: 5px 20px"
                                            v-show="
                        row.item.pivot.status == 'express_interest_accepted'
                      "
                                            :disabled="true"
                                        >
                                            Accepted
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-outline-primary ml-2"
                                            style="border-radius: 5px; padding: 5px 20px"
                                            v-show="
                        row.item.pivot.status == 'express_interest_rejected'
                      "
                                            :disabled="true"
                                        >
                                            Declined
                                        </button>
                                    </template>
                                    <template v-slot:cell(compliant)="row">
                                        <i
                                            v-if="row.item.compliant"
                                            class="fas fa-check-circle"
                                            style="font-size: 20px; color: #5F2EEA;"
                                        ></i>
                                        <i
                                            v-else
                                            class="fas fa-times-circle"
                                            style="font-size: 20px; color: rgb(237, 46, 126)"
                                        ></i>
                                    </template>
                                    <!-- <template v-slot:cell(message)>
                                      <i
                                        class="far fa-comment-alt"
                                        style="font-size: 24px; color: #4682b4"
                                      ></i>
                                    </template> -->
                                    <template #empty class="text-center">
                                        No Data Found
                                    </template>
                                </b-table>
                            </b-tab>

                            <b-tab
                                @click="getSubmittedTenders"
                            >
                                <template #title>
                                    <span class="tab-icon"><i class="fas fa-gavel"></i></span>
                                    <span class="tab-icon-title">SUBMITTED TENDERS</span>
                                    {{
                                        counts.submitted_tenders
                                            ? `[${counts.submitted_tenders}]`
                                            : '[0]'
                                    }}
                                </template>

                                <b-table
                                    responsive
                                    striped
                                    hover
                                    :items="submittedTenders"
                                    :fields="tenderSubmittedFields"
                                    show-empty
                                >
                                    <template v-slot:cell(files)="row">
                                        <p
                                            v-for="(document, index) in row.item.pivot.media"
                                            :key="index"
                                        >
                                            <a :href="document.signed_url" target="_blank" download>{{
                                                    document.name
                                                }}</a>
                                        </p>
                                        <!-- <i class="fas fa-paperclip"></i> {{row.item.pivot.media}} -->
                                    </template>
                                    <template v-slot:cell(compliant)="row">
                                        <i
                                            v-if="row.item.compliant"
                                            class="fas fa-check-circle"
                                            style="font-size: 20px; color: #5F2EEA;"
                                        ></i>
                                        <i
                                            v-else
                                            class="fas fa-times-circle"
                                            style="font-size: 20px; color: rgb(237, 46, 126)"
                                        ></i>
                                    </template>
                                    <template v-slot:cell(action)="row">
                                        <button
                                            class="btn btn-primary"
                                            style="border-radius: 5px; padding: 5px 20px;"
                                            v-show="
                        row.item.pivot_is_awarded == null &&
                        quote.status != 'granted' &&
                        quoteAwarded == false &&
                        row.item.quote_business_status != 'edit_bid_accepted' &&
                        row.item.quote_business_status != 'edit_bid_rejected' &&
                        row.item.quote_business_status != 'edit_bid_requested'
                      "
                                            @click="confirmAwardTender(row.item)"
                                        >
                                            Award
                                        </button>

                                        <button
                                            class="btn btn primary"
                                            style="border-radius: 5px; padding: 5px 20px;"
                                            v-if="
                        row.item.pivot_is_awarded == null &&
                        quote.status == 'granted' &&
                        quoteAwarded == false &&
                        row.item.quote_business_status != 'edit_bid_accepted' &&
                        row.item.quote_business_status != 'edit_bid_rejected' &&
                        row.item.quote_business_status != 'edit_bid_requested'
                      "
                                            @click="confirmAwardTender(row.item)"
                                            :disabled="true"
                                        >
                                            Award
                                        </button>

                                        <button
                                            class="btn btn-primary"
                                            style="border-radius: 5px; padding: 5px 20px;"
                                            v-if="
                        quoteAwarded == true &&
                        row.item.pivot_is_awarded != true &&
                        row.item.quote_business_status != 'edit_bid_accepted' &&
                        row.item.quote_business_status != 'edit_bid_rejected' &&
                        row.item.quote_business_status != 'edit_bid_requested'
                      "
                                            @click="confirmAwardTender(row.item.pivot)"
                                            :disabled="true"
                                        >
                                            Award
                                        </button>

                                        <button
                                            class="btn btn-primary"
                                            style="border-radius: 5px; padding: 5px 20px;"
                                            v-show="row.item.pivot_is_awarded == true"
                                            :disabled="true"
                                        >
                                            Awarded
                                        </button>

                                        <div
                                            v-if="
                        row.item.quote_business_status ==
                          'edit_bid_requested' ||
                        row.item.quote_business_status == 'edit_bid_accepted' ||
                        row.item.quote_business_status == 'edit_bid_rejected'
                      "
                                        >
                                            <h6>Do you want to accept request To edit bid?</h6>
                                            <button
                                                type="button"
                                                class="btn btn-outline-primary ml-2"
                                                style="border-radius: 5px; padding: 5px 20px"
                                                v-show="row.item.pivot.status == 'edit_bid_accepted'"
                                                :disabled="true"
                                            >
                                                Accepted
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-outline-primary ml-2"
                                                style="border-radius: 5px; padding: 5px 20px"
                                                v-show="row.item.pivot.status == 'edit_bid_rejected'"
                                                :disabled="true"
                                            >
                                                Declined
                                            </button>
                                            <button
                                                v-if="row.item.pivot.status == 'edit_bid_requested'"
                                                type="button"
                                                class="btn btn-primary"
                                                style="border-radius: 5px; padding: 5px 20px"
                                                @click="confirmAcceptToUpdateBidRequest(row.item)"
                                            >
                                                Accept
                                            </button>

                                            <button
                                                v-if="row.item.pivot.status == 'edit_bid_requested'"
                                                type="button"
                                                class="btn btn-outline-primary"
                                                style="border-radius: 5px; padding: 5px 20px"
                                                @click="confirmRejectToUpdateBidRequest(row.item)"
                                            >
                                                Decline
                                            </button>
                                        </div>
                                    </template>
                                    <template v-slot:cell(message)="row">
                                        <i
                                            class="fas fa-comment-alt"
                                            style="font-size: 24px; color: #5F2EEA;"
                                            @click="
                        openChat(
                          row.item.pivot.id,
                          row.item.pivot.receiving_business,
                          row.item.business,
                          'Invited Contractor'
                        )
                      "
                                        ></i>
                                        <span class="msg-count">{{ row.item.unread_count }}</span>
                                    </template>
                                    <template #empty class="text-center">
                                        No Data Found
                                    </template>
                                </b-table>
                                <!-- <b-button variant="outline-primary" class="btn-open py-2" style="font-size: 12px; padding: 0px 15px;float:right" >Export All</b-button> -->
                            </b-tab>

                            <b-tab :title-item-class=" activeTab == 'chat' ? 'd-block':'d-none'"
                                   :active="activeTab == 'chat'">
                                <template #title>
                                    <span class="tab-icon"><i class="fas fa-comment-alt"></i></span>
                                    <span class="tab-icon-title">MESSAGES</span>
                                </template>
                                <div class="chat-main-box">
                                    <h5>
                                        {{ activeChatBoxInfo.receiverBusinessDetails.company_name }}
                                        ({{ activeChatBoxInfo.contractorOf }})
                                    </h5>
                                </div>
                                <div style="padding: 50px 50px 0px 50px; border: 1px solid lightgrey">
                                    <b-row>
                                        <div v-if="chatMessages.length > 0" id="chat-message" class="chat-message mb-4">
                                            <b-col
                                                v-for="message in this.chatMessages"
                                                :key="`ch-m${message.timestamp}-${message.sending_user_id}-${message.receiving_user_id}`"
                                                md="12"
                                                :class="
                          activeChatBoxInfo.senderBusinessDetails.id ==
                          message.sending_business_id
                            ? 'sending-message mb-4'
                            : 'receiving-message mb-4'
                        "
                                            >
                                                <p v-if="message.type == 'image'" :class="
                            activeChatBoxInfo.senderBusinessDetails.id ==
                            message.sending_business_id
                              ? 'chat-msg-right mb-1 p-0'
                              : 'chat-msg-left mb-1 p-0'
                          ">
                                                    <a :href="message.message" target="_blank"><img
                                                        :src="message.message" width="200px;"></a>
                                                </p>

                                                <a v-if="message.type == 'file'" :href="message.message"
                                                   target="_blank"><p :class="
                            activeChatBoxInfo.senderBusinessDetails.id ==
                            message.sending_business_id
                              ? 'file mb-1'
                              : 'file mb-1'
                          ">
                                                    <pre
                                                        :style="activeChatBoxInfo.senderBusinessDetails.id == message.sending_business_id ? 'color:#ffffff;font-family:Lexend;margin-bottom:0px;':'color:#000000;font-family:Lexend;margin-bottom:0px;' ">{{
                                                            message.file_name
                                                        }}</pre>
                                                    </p></a>

                                                <p v-if="message.type == 'message'" :class="
                            activeChatBoxInfo.senderBusinessDetails.id ==
                            message.sending_business_id
                              ? 'chat-msg-right mb-1'
                              : 'chat-msg-left mb-1'
                          ">
                                                    <span
                                                        :style="activeChatBoxInfo.senderBusinessDetails.id == message.sending_business_id ? 'color:#ffffff;font-family:Lexend;margin-bottom:0px;':'color:#000000;font-family:Lexend;margin-bottom:0px;' ">{{
                                                            message.message
                                                        }}</span>
                                                </p>

                                                <div v-if="activeChatBoxInfo.senderBusinessDetails.id ==
                          message.sending_business_id" class="d-flex" style="justify-content: right">
                                                    <span
                                                        style="font-size:12px;color:grey;">   {{ message.sending_business_details.company_name }} |  {{ message.timestamp.seconds ? momentDate(message.timestamp) : '' }}</span>
                                                </div>
                                                <div v-else class="d-flex" style="justify-content: left">
                                                    <span
                                                        style="font-size:12px;color:grey;">   {{ message.sending_business_details.company_name }} |   {{ message.timestamp.seconds ? momentDate(message.timestamp) : '' }}</span>
                                                </div>

                                            </b-col>

                                            <!-- <b-col :v-if="activeChatBoxInfo.senderBusinessDetails.id == message.sending_business_id" md="12" class="sending-message">
                                              <p class="chat-msg-right">
                                                I'm all good.What about you?
                                              </p>
                                            </b-col> -->
                                        </div>
                                        <div v-else id="chat-message" class="chat-message mb-4">
                                            <b-col class="sending-message mb-4 text-right">
                                                <p :class="'chat-msg-right mb-1'">
                                                <pre :style="'color:#ffffff;font-family:Lexend;margin-bottom:0px;'">Start a chat by sending a message....</pre>
                                                </p>
                                            </b-col>
                                        </div>

                                        <div class="w-100 pb-4" v-if="quote.status_parsed != 'over-due'">
                                            <b-col md="12">
                                                <div class="chatbox">
                                                    <b-textarea
                                                        @keydown.enter.exact.prevent
                                                        @keyup.enter.exact="sendMessage"
                                                        @keydown.enter.shift.exact="newline"
                                                        v-model="message"
                                                        placeholder="Enter a message here...">
                                                    </b-textarea>

                                                    <div class="chatbox-icons">
                                                        <div class="send-file icons-props">
                                                            <label for="file-input">
                                                                <i class="fas fa-paperclip fa-lg"></i>
                                                            </label>
                                                            <input id="file-input" type="file" plain multiple
                                                                   @change="sendAttachment($event, 'file')"/>
                                                        </div>

                                                        <div class="send-img icons-props">
                                                            <label for="file-input2">
                                                                <i class="fas fa-image fa-lg"></i>
                                                            </label>
                                                            <input id="file-input2" type="file" plain multiple
                                                                   @change="sendAttachment($event, 'image')"/>
                                                        </div>

                                                        <span class="send-icon" :disabled="message == ''"
                                                              @click="sendMessage()"><i
                                                            class="fas fa-paper-plane fa-lg"></i></span>
                                                    </div>
                                                </div>
                                            </b-col>
                                        </div>
                                    </b-row>
                                </div>
                                <p v-if="quote.status_parsed == 'over-due'" style="color:rgb(233, 22, 22);"
                                   class="mt-3">The quote has already expired. You cannot message right now.</p>
                            </b-tab>
                        </b-tabs>


                        <!-- Work Order -->
                        <b-tabs
                            content-class="mt-3"
                            class="manager-quote-tab ml-4"
                            v-if="workOrder"
                        >
                            <b-tab :title="'PROGRESS FILE'" @click="getProgress">
                                <b-table
                                    striped
                                    hover
                                    :items="progressFileItems"
                                    :fields="progressFileFields"
                                    show-empty
                                >
                                    <template v-slot:cell(Download)="row">
                                        <div
                                            v-for="(document, index) in row.item.progressDetail.media"
                                            :key="index"
                                        >
                                            <a :href="document.signed_url" target="_blank"
                                            ><p>{{ row.item.progressDetail.media[0].name }}</p></a
                                            >
                                        </div>
                                    </template>
                                    <template #empty class="text-center">
                                        The progress file is empty.
                                    </template>
                                </b-table>

                                <!-- verify completion -->
                                <div class="verify-modal">
                                    <div class="verify-email d-flex">
                                        <a href="#!" class="btn btn-primary ml-auto" v-b-modal=" 'verify' ">Verify</a>
                                    </div>
                                </div>

                                <b-modal id="verify" centered style="padding: 0 !important;">
                                    <template #modal-title>
                                        <h2>Contractor Feedback</h2>
                                        <p class="sub-title">Please provide feedback and rating for the Contractor</p>
                                    </template>

                                    <div class="rate-content">
                                        <p>How would you rate it?</p>
                                        <b-form-rating show-value size="lg" color="#5F2EEA" class="star my-2"
                                                       v-model="verifyForm.rating"></b-form-rating>
                                        <h5 class="my-3">Comments</h5>

                                        <b-form-textarea id="textarea" v-model="verifyForm.comment"
                                                         placeholder="Enter something..."></b-form-textarea>

                                        <div class="rating-val">
                                            <label for="rate">Rates and fees</label>
                                            <b-form-rating id="rate" inline value="0" size="lg" color="#5F2EEA"
                                                           v-model="verifyForm.rating_rate_fee"></b-form-rating>
                                        </div>

                                        <div class="rating-val">
                                            <label for="time">Timeliness</label>
                                            <b-form-rating id="time" inline value="0" size="lg" color="#5F2EEA"
                                                           v-model="verifyForm.rating_timeliness"></b-form-rating>
                                        </div>

                                        <div class="rating-val">
                                            <label for="job">Job Satisfaction</label>
                                            <b-form-rating id="job" inline value="0" size="lg" color="#5F2EEA"
                                                           v-model="verifyForm.rating_job_satisfaction"></b-form-rating>
                                        </div>

                                        <div class="rating-val">
                                            <label for="transparent">Transparency</label>
                                            <b-form-rating id="transparent" inline value="0" size="lg" color="#5F2EEA"
                                                           v-model="verifyForm.rating_transparency"></b-form-rating>
                                        </div>
                                    </div>

                                    <template #modal-footer="{ ok, cancel }">
                                        <b-button size="md" variant="primary" @click.prevent="verifySubmit()">Submit
                                        </b-button>
                                        <b-button size="md" variant="danger" @click="cancel()">Cancel</b-button>
                                    </template>
                                </b-modal>
                            </b-tab>
                            <b-tab
                                :title="
                  'AWARDED TENDER' +
                  (counts.awarded_tenders ? `[${counts.awarded_tenders}]` : '')
                "
                                @click="getAwardedTenders"
                            >
                                <!-- <b-button variant="outline-primary" class="btn-open py-2 mb-2" style="font-size: 12px; padding: 0px 15px;float:right" >Export Details</b-button> -->
                                <b-table
                                    striped
                                    hover
                                    :items="awardedTenderItems"
                                    :fields="awardedTenderFields"
                                    show-empty
                                >
                                    <template v-slot:cell(Files)="row">
                                        <p
                                            v-for="(document, index) in row.item.awardedTenderDetails
                        .media"
                                            :key="index"
                                        >
                                            <a :href="document.signed_url" target="_blank" download>{{
                                                    document.name
                                                }}</a>
                                        </p>
                                        <!-- <i class="fas fa-paperclip"></i> {{row.item.pivot.media}} -->
                                    </template>
                                    <template v-slot:cell(compliant)="row">
                                        <i
                                            v-if="row.item.compliant"
                                            class="fas fa-check-circle"
                                            style="font-size: 20px; color: #5F2EEA;"
                                        ></i>
                                        <i
                                            v-else
                                            class="fas fa-times-circle"
                                            style="font-size: 20px; color: rgb(237, 46, 126)"
                                        ></i>
                                    </template>

                                    <template v-slot:cell(message)="row">
                                        <i
                                            class="fas fa-comment-alt"
                                            style="font-size: 24px; color: #5F2EEA;"
                                            @click="
                        openChat(
                          row.item.pivot.id,
                          row.item.pivot.receiving_business,
                          row.item.business,
                          'Awarded Contractor'
                        )
                      "
                                        ></i>
                                        <span class="msg-count">{{ row.item.unread_count }}</span>
                                    </template>

                                    <!-- <template v-slot:cell(message)="row">
                                      <i
                                        class="far fa-comment-alt"
                                        style="font-size: 24px; color: #4682b4"
                                        @click="
                                          openChat(
                                            row.item.pivot.id,
                                            row.item.pivot.receiving_business,
                                            row.item.business,
                                            'Awarded Contractor'
                                          )
                                        "
                                      ></i>
                                      <span style="background: #e42222;color: white;padding: 5px 10px;border-radius: 50%;font-size: 15px;">{{row.item.unread_count}}</span>
                                    </template> -->
                                    <template #empty class="text-center">
                                        No Data Found
                                    </template>
                                </b-table>

                                <b-button
                                    variant="primary"
                                    class="py-2"
                                    style="font-size: 12px; padding: 0px 15px; float: right"
                                    @click="getNotAwardedTenders"
                                >Others
                                </b-button
                                >

                                <div v-if="showNotAwardedContractors">
                                    <b-table
                                        striped
                                        hover
                                        :items="notAwardedTenderItems"
                                        :fields="notAwardedTenderFields"
                                        show-empty
                                    >
                                        <template v-slot:cell(Files)="row">
                                            <p
                                                v-for="(document, index) in row.item
                          .notAwardedTenderDetails.media"
                                                :key="index"
                                            >
                                                <a
                                                    :href="document.signed_url"
                                                    target="_blank"
                                                    download
                                                >{{ document.name }}</a
                                                >
                                            </p>
                                            <!-- <i class="fas fa-paperclip"></i> {{row.item.pivot.media}} -->
                                        </template>
                                        <template v-slot:cell(Message)>
                                            <i
                                                class="far fa-comment-alt"
                                                style="font-size: 24px; color: #4682b4"
                                            ></i>
                                        </template>
                                        <template v-slot:cell(Action)="row">
                                            <button
                                                type="button"
                                                class="btn btn-primary ml-2"
                                                style="
                          border-radius: 5px;
                          padding: 5px 10px;
                          font-size: 12px;
                        "
                                                @click="
                          confirmNotAwardedTender(
                            row.item.not_awarded_tender_id,
                            're-assign'
                          )
                        "
                                            >
                                                Contractor Re-assign
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-primary ml-2"
                                                style="
                          border-radius: 5px;
                          padding: 5px 10px;
                          font-size: 12px;
                        "
                                                @click="
                          confirmNotAwardedTender(
                            row.item.not_awarded_tender_id,
                            're-quote'
                          )
                        "
                                            >
                                                Request Re-quote
                                            </button>
                                        </template>
                                        <template #empty class="text-center">
                                            No Data Found
                                        </template>
                                    </b-table>
                                    <b-button
                                        variant="danger"
                                        class="py-2"
                                        style="font-size: 12px; padding: 0px 15px; float: right"
                                        @click="showNotAwardedContractors = false"
                                    >Close
                                    </b-button
                                    >
                                </div>
                            </b-tab>
                            <b-tab :title-item-class=" activeTab == 'chat' ? 'd-block':'d-none'" :title="'MESSAGES'"
                                   :active="activeTab == 'chat'">
                                <div class="chat-main-box">
                                    <h5>
                                        {{ activeChatBoxInfo.receiverBusinessDetails.company_name }}
                                        ({{ activeChatBoxInfo.contractorOf }})
                                    </h5>
                                </div>
                                <div style="padding: 50px 50px 0px 50px; border: 1px solid lightgrey">
                                    <b-row>
                                        <div v-if="chatMessages.length > 0" id="chat-message" class="chat-message mb-4">
                                            <b-col
                                                v-for="message in this.chatMessages"
                                                :key="`ch-m${message.timestamp}-${message.sending_user_id}-${message.receiving_user_id}`"
                                                md="12"
                                                :class="
                          activeChatBoxInfo.senderBusinessDetails.id ==
                          message.sending_business_id
                            ? 'sending-message mb-4'
                            : 'receiving-message mb-4'
                        "
                                            >
                                                <p v-if="message.type == 'image'" :class="
                            activeChatBoxInfo.senderBusinessDetails.id ==
                            message.sending_business_id
                              ? 'chat-msg-right mb-1 p-0'
                              : 'chat-msg-left mb-1 p-0'
                          ">
                                                    <a :href="message.message" target="_blank"><img
                                                        :src="message.message" width="200px;"></a>
                                                </p>

                                                <a v-if="message.type == 'file'" :href="message.message"
                                                   target="_blank"><p :class="
                            activeChatBoxInfo.senderBusinessDetails.id ==
                            message.sending_business_id
                              ? 'file mb-1'
                              : 'file mb-1'
                          ">
                                                    <pre
                                                        :style="activeChatBoxInfo.senderBusinessDetails.id == message.sending_business_id ? 'color:#ffffff;font-family:Lexend;margin-bottom:0px;':'color:#000000;font-family:Lexend;margin-bottom:0px;' ">{{
                                                            message.file_name
                                                        }}</pre>
                                                    </p></a>

                                                <p v-if="message.type == 'message'" :class="
                            activeChatBoxInfo.senderBusinessDetails.id ==
                            message.sending_business_id
                              ? 'chat-msg-right mb-1'
                              : 'chat-msg-left mb-1'
                          ">
                                                <pre
                                                    :style="activeChatBoxInfo.senderBusinessDetails.id == message.sending_business_id ? 'color:#ffffff;font-family:Lexend;margin-bottom:0px;':'color:#000000;font-family:Lexend;margin-bottom:0px;' ">{{
                                                        message.message
                                                    }}</pre>
                                                </p>

                                                <div v-if="activeChatBoxInfo.senderBusinessDetails.id ==
                          message.sending_business_id" class="d-flex" style="justify-content: right">
                                                    <span
                                                        style="font-size:12px;color:grey;">   {{ message.sending_business_details.company_name }} |  {{ message.timestamp.seconds ? momentDate(message.timestamp) : '' }}</span>
                                                </div>
                                                <div v-else class="d-flex" style="justify-content: left">
                                                    <span
                                                        style="font-size:12px;color:grey;">   {{ message.sending_business_details.company_name }} |   {{ message.timestamp.seconds ? momentDate(message.timestamp) : '' }}</span>
                                                </div>

                                            </b-col>

                                            <!-- <b-col :v-if="activeChatBoxInfo.senderBusinessDetails.id == message.sending_business_id" md="12" class="sending-message">
                                              <p class="chat-msg-right">
                                                I'm all good.What about you?
                                              </p>
                                            </b-col> -->
                                        </div>
                                        <div v-else id="chat-message" class="chat-message mb-4">
                                            <b-col class="sending-message mb-4 text-right">
                                                <p :class="'chat-msg-right mb-1'">
                                                <pre :style="'color:#ffffff;font-family:Lexend;margin-bottom:0px;'">Start a chat by sending a message....</pre>
                                                </p>
                                            </b-col>
                                        </div>

                                        <div class="w-100 pb-4" v-if="quote.status_parsed != 'over-due'">
                                            <b-col md="12">
                                                <b-textarea
                                                    @keydown.enter.exact.prevent
                                                    @keyup.enter.exact="sendMessage"
                                                    @keydown.enter.shift.exact="newline"
                                                    v-model="message"
                                                    placeholder="Enter a message here..."
                                                ></b-textarea>

                                                <b-row>
                                                    <b-col>
                                                        <label>Choose Image</label>
                                                        <b-file class="mt-3" plain multiple
                                                                @change="sendAttachment($event, 'image')"></b-file>
                                                    </b-col>
                                                    <b-col>
                                                        <label>Choose File</label>
                                                        <b-file class="mt-3" plain multiple
                                                                @change="sendAttachment($event, 'file')"></b-file>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col md="12" class="text-right mt-3">
                                                <b-button variant="primary" :disabled="message == ''"
                                                          @click="sendMessage()"
                                                >Send &nbsp;<i class="fa fa-paper-plane"></i
                                                ></b-button>
                                            </b-col>
                                        </div>
                                    </b-row>
                                </div>
                                <p v-if="quote.status_parsed == 'over-due'" style="color:rgb(233, 22, 22)" class="mt-3">
                                    The quote has already expired. You cannot message right now.</p>
                            </b-tab>
                        </b-tabs>
                    </div>

                    <div
                        class="work-session mt-4 pt-4 pb-5"
                        style="
              background-color: #ffffff;
              box-shadow: 1px 3px 10px rgba(233, 239, 244, 0.81);
            "
                    >
                        <h4 style="font-size: 20px; color: #333333" class="ml-4 mb-3">
                            Audit Logs
                            <b-button
                                @click="handleAuditLogsDownloadClicked"
                                class="btn btn-primary ml-auto mr-3"
                                style="border-radius: 5px; padding: 5px 15px"
                                variant="primary"
                            >
                                <i class="fas fa-download"></i>
                            </b-button>
                        </h4>
                        <b-table hover :items="auditLogs" :fields="auditLogsFields">
                        </b-table>
                        <div v-show="auditLogsHasMorePages">
                            <a
                                @click.prevent="fetchAuditLogs(++auditLogsPage)"
                                class="d-block text-center"
                                style="cursor: pointer"
                            >Load more...</a
                            >
                        </div>
                    </div>
                </b-col>

                <b-col xl="4" lg="5" md="12" sm="12" class="mt-3 pl-lg-3 px-md-5">
                    <div
                        style="
              background-color: #fff;
              box-shadow: 1px 3px 10px rgba(233, 239, 244, 0.81);
            "
                        class="section-second p-5"
                    >

                        <!-- status => workorder -->
                        <div v-if="workOrder" class="text-center">
                            <b-button
                                class="btn-invite"
                                variant="primary"
                                style="
                  font-size: 14px;
                  border: 2px solid #4682b4;
                  font-size: 15px;
                  padding: 15px 95px;
                "
                                v-if="quote.status == 'granted' && quote.is_work_order == true"
                            >Awarded
                            </b-button
                            >
                            <b-button
                                class="btn-invite px-4 py-3"
                                variant="primary"
                                style="
                  font-size: 14px;
                  border: 2px solid #4682b4;
                  border-radius: 32px;   "
                                v-if="
                  quote.status_parsed == 'active' ||
                  quote.status_parsed == 'open' ||
                  quote.status_parsed == 'due' ||
                  quote.status_parsed == 'over-due'"
                                :to="{
                  name: 'manager-workorder-edit',
                  params: { id: $route.params.id, step: 4 }}">Invite Contractors to Quote
                            </b-button>
                        </div>

                        <!-- status => not workorder -->
                        <div v-if="!workOrder" class="quote-status">
                            <div class="quote-status-btns">
                                <!-- open -->
                                <button class="btn btn-stat btn-stat-open"
                                        v-if="quote.status_parsed == 'open' && quoteAwarded == false">Open
                                </button>

                                <!-- active -->
                                <button class="btn btn-stat btn-stat-active"
                                        v-if="quote.status_parsed == 'active' && quoteAwarded == false">Active
                                </button>

                                <!-- active due soon quotes -->
                                <b-button class="btn btn-stat btn-stat-active" v-if="quote.status_parsed == 'active-due-quotes'">Active
                                    {{ subtractedDate == 1 ? '(Expiring in ' + subtractedDate + ' day)' : subtractedDate > 1 ? '(Expiring in ' + subtractedDate + ' days)' : '(Expiring Today)' }}
                                </b-button>

                                <b-button class="btn btn-stat" v-if="  quote.status_parsed == 'pending-approval' &&   quoteAwarded == false">Pending Approval</b-button>

                                <b-button class="btn btn-stat"  v-if="quote.status_parsed == 'due' && quoteAwarded == false"  >
                                    Due Soon {{ "(" + subtractedDate + " Days Left)" }}
                                </b-button>

                                <!-- For Open Due soon quotes -->
                                <!-- this open is inside -->
                                <button class="btn btn-stat" v-if="quote.status_parsed == 'open-due-quotes'">Open
                                    {{ subtractedDate == 1 ? '(Expiring in ' + subtractedDate + ' day)' : subtractedDate > 1 ? '(Expiring in ' + subtractedDate + ' days)' : '(Expiring Today)' }}
                                </button>

                                <b-button
                                    class="btn btn-stat overdue-btn"
                                    v-if="quote.status_parsed == 'over-due' && quoteAwarded == false">Overdue {{ "(" + subtractedDate + " Days Passed)" }}
                                </b-button>

                                <b-button
                                    class="btn btn-stat"
                                    v-if="quote.status_parsed == 'draft' && quoteAwarded == false">Draft
                                </b-button>

                                <b-button
                                    class="btn btn-stat"
                                    v-if="quote.status_parsed == 'completed' || quoteAwarded == true">Completed
                                </b-button>

                                <div v-if="quote.status_parsed == 'over-due'">
                                    <p style="color:rgb(233, 22, 22); margin-top: 10px; font-size: 12px;">The quote has already expired.</p>
                                </div>
                            </div>

                            <div v-if="$store.state.authenticatedUserData.user.id === quote.manager.id && !workOrder "
                                 class="quote-btns mb-3">
                                <b-button
                                    class="btn-invite"
                                    variant="primary"
                                    style="font-size: 14px"
                                    v-if="
                        quote.status_parsed == 'active' ||
                        quote.status_parsed == 'open' ||
                        quote.status_parsed == 'due' ||
                        quote.status_parsed == 'open-due-quotes' ||
                        quote.status_parsed == 'active-due-quotes'"
                                    :to="{  name: 'manager-quote-edit',params: { id: $route.params.id, step: 4 }}">
                                    Invite Contractors to Quote
                                </b-button>

                                <b-button
                                    class="btn-invite"
                                    variant="primary"
                                    v-else
                                    :disabled="true">Invite Contractors to Quote
                                </b-button>

                                <!-- <b-button
                                    variant="outline-primary"
                                    class="btn-open py-3 ml-3"
                                    style="font-size: 14px; padding: 0px 20px; border-radius: 32px"
                                    v-if="quote.status_parsed == 'open' && quoteAwarded == false"
                                    >Open</b-button
                                >
                                <b-button
                                    variant="outline-primary"
                                    class="btn-open py-3 ml-3"
                                    style="font-size: 14px; padding: 0px 20px; border-radius: 32px"
                                    v-if="quote.status_parsed == 'active' && quoteAwarded == false"
                                    >Active</b-button
                                > -->

                                <!-- For Active Due soon quotes -->
                                <!-- <b-button
                                    variant="outline-primary"
                                    class="btn-open py-3 ml-3"
                                    style="font-size: 14px; padding: 0px 20px; border-radius: 32px"
                                    v-if="quote.status_parsed == 'active-due-quotes'"
                                    >Active  {{ subtractedDate == 1 ?  '(Expiring in '+subtractedDate + ' day)' : subtractedDate > 1 ?  '(Expiring in ' + subtractedDate + ' days)' : '(Expiring Today)'}}</b-button
                                >

                                <b-button
                                    variant="outline-primary"
                                    class="btn-open py-3 ml-3"
                                    style="font-size: 14px; padding: 0px 20px; border-radius: 32px"
                                    v-if="
                                    quote.status_parsed == 'pending-approval' &&
                                    quoteAwarded == false
                                    "
                                    >Pending Approval
                                </b-button>

                                <b-button
                                    variant="outline-primary"
                                    class="btn-open py-3 ml-3"
                                    style="font-size: 14px; padding: 0px 20px; border-radius: 32px"
                                    v-if="quote.status_parsed == 'due' && quoteAwarded == false"
                                    >Due Soon {{ "(" + subtractedDate + " Days Left)" }}</b-button
                                > -->

                                <!-- For Open Due soon quotes -->
                                <!-- <b-button
                                    variant="outline-primary"
                                    class="btn-open py-3 ml-3"
                                    style="font-size: 14px; padding: 0px 20px; border-radius: 32px"
                                    v-if="quote.status_parsed == 'open-due-quotes'"
                                    >Open  {{ subtractedDate == 1 ?  '(Expiring in '+subtractedDate + ' day)' : subtractedDate > 1 ?  '(Expiring in ' + subtractedDate + ' days)' : '(Expiring Today)'}}</b-button>

                                <b-button
                                    variant="outline-primary"
                                    class="btn-open overdue-btn"
                                    style="font-size: 14px; padding: 11px 19px; border-radius: 32px"
                                    v-if="
                                    quote.status_parsed == 'over-due' && quoteAwarded == false
                                    "
                                    >Overdue {{ "(" + subtractedDate + " Days Passed)" }}</b-button
                                >

                                <b-button
                                    variant="outline-primary"
                                    class="btn-open py-3 ml-3"
                                    style="font-size: 14px; padding: 0px 20px; border-radius: 32px"
                                    v-if="quote.status_parsed == 'draft' && quoteAwarded == false"
                                    >Draft
                                </b-button>

                                <b-button
                                    variant="outline-primary"
                                    class="btn-open py-3 ml-3"
                                    style="font-size: 14px; padding: 0px 20px; border-radius: 32px"
                                    v-if="
                                    quote.status_parsed == 'completed' || quoteAwarded == true
                                    "
                                    >Completed
                                </b-button> -->
                            </div>
                        </div>

                        <hr class="my-3">
                        <!-- status ends -->


                        <div class="deatil-content">
                            <h5 class="font-weight-bold pb-2" style="font-size: 16px">
                                Quote Details
                            </h5>

                            <ul>
                                <li v-if="!workOrder && quote.site_contact_name"><span
                                    class="title">Site contact name:</span> <span
                                    class="sub-title">{{ quote.site_contact_name }}</span></li>

                                <li v-if="!workOrder && quote.site_access_contact"><span class="title">Site access contact:</span>
                                    <span class="sub-title">{{ quote.site_access_contact }}</span></li>

                                <li v-if="!workOrder && quote.site_access_email"><span
                                    class="title">Site access email:</span> <span
                                    class="sub-title">{{ quote.site_access_email }}</span></li>

                                <li><span class="title">Date Posted:</span> <span class="sub-title">{{
                                        quote.issue_date
                                    }}</span></li>

                                <li v-if="!workOrder && quote.due_date"><span class="title">Due by:</span> <span
                                    class="sub-title">{{ quote.due_date }}</span></li>

                                <li><span class="title">Address:</span> <span
                                    class="sub-title">{{ quote.strata_plan.street }},
                    {{ quote.strata_plan.suburb }}, {{ quote.strata_plan.state }}
                    {{ quote.strata_plan.postcode }}</span></li>

                                <li v-if="quote.address_note"><span class="title">Address Note:</span> <span
                                    class="sub-title">{{ quote.address_note }}</span></li>

                                <li><span class="title">Budget Estimate (ex. GST) :</span>
                                    <span class="sub-title ml-2" style="flex: 0 0 120px;">
                        <span v-if="quote.min_estimate_budget != null">${{ quote.min_estimate_budget.toLocaleString() }} -
                    </span>
                    <span v-if="quote.max_estimate_budget != null"
                    >${{ quote.max_estimate_budget.toLocaleString() }}</span
                    ></span></li>

                            </ul>
                        </div>

                        <hr class="my-3">

                        <h5 class="font-weight-bold" style="font-size: 16px; color: #333333;">Attached File(s)</h5>
                        <div class="d-flex">
                            <div
                                class=""
                                v-for="(file, index) in quote.attachments"
                                :key="index"
                            >
                                <a
                                    style="
                    text-decoration: underline;
                    font-size: 12.5px;
                  "
                                    target="_blank"
                                    download
                                    :href="file.signed_url"
                                >{{ file.name }}
                                </a>
                            </div>
                        </div>
                        <hr class="my-3">

                        <h5 class="font-weight-bold pb-2" style="font-size: 16px">
                            Worksite image(s):
                        </h5>

                        <b-row class="mb-4">
                            <b-col
                                class="mb-3"
                                md="6"
                                v-for="(photo, index) in quote.site_photos"
                                :key="index"
                            >
                                <img
                                    :src="photo.signed_url"
                                    class="img-fluid"
                                    :style="{ height: '150px' }"
                                    @click="handleWorkSiteImageClick(photo.signed_url)"
                                />
                            </b-col>
                            <b-modal id="modal-work-site-image" hide-footer hide-header>
                                <img
                                    :src="workSiteModalImageLink"
                                    alt="Snow"
                                    class="img-fluid"
                                />
                            </b-modal>
                        </b-row>
                    </div>
                </b-col>
            </b-row>

            <b-row class="bottom-content">
                <b-col class="pl-lg-5 px-md-5 mt-3 mb-2">
                    <footer-component></footer-component>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import NavBar from "../../includes/NavBar.vue";
import moment from "moment";
import _ from "lodash";
import axios from "axios";
import Swal from "sweetalert2";
import phoneNoMixin from "../../../../../mixins/phoneNoMixin";
import FooterComponent from "../../../includes/FooterComponent.vue";
import {getFirestore} from "firebase/firestore";
import {Form} from "vform";

import {
    addDoc,
    doc,
    collection,
    getDocs,
    setDoc,
    limit,
    where,
    query,
    orderBy,
    onSnapshot,
    startAfter,
    endAt,
    endBefore,
    limitToLast,
    updateDoc,
} from "firebase/firestore";

import {ref, uploadBytes, getDownloadURL} from "firebase/storage";

export default {
    components: {
        NavBar,
        FooterComponent,
    },
    props: {
        workOrder: String,
    },
    mixins: [phoneNoMixin],
    data() {
        return {
            boxTwo: "",
            quote: {
                business: {},
                categories: {},
                invited_businesses: {},
                manager: {},
                strata_plan: {},
                creating_user: {},
                status_parsed: "",
            },
            invitedContractorsItems: [],
            expressionOfInterest: [],
            submittedTenders: [],
            invitedContractorsItemsFields: [
                {key: "company_name", sortable: true},
                {key: "compliant", sortable: true},
                {key: "status", sortable: true},
                {key: "sent", sortable: true},
                {key: "message", sortable: true},
            ],
            expressionOfInterestFields: [
                {key: "company_name", sortable: true},
                {key: "compliant", sortable: true},
                {key: "action", sortable: true},
            ],
            tenderSubmittedFields: [
                {key: "company_name", sortable: true},
                {key: "compliant", sortable: true},
                {key: "amount", sortable: true},
                {key: "files", sortable: true},
                {key: "action", sortable: true},
                {key: "message", sortable: true},
            ],
            auditLogs: [],
            auditLogsFields: [
                {key: "date_time", sortable: false},
                {key: "message", sortable: false},
                {key: "editing_user_name", sortable: false},
            ],
            auditLogsHasMorePages: false,
            auditLogsPage: 1,

            //Work Order
            progressFileItems: [],
            progressFileFields: [
                {key: "Progress", sortable: true},
                {key: "Description", sortable: true},
                {key: "Date", sortable: true},
                {key: "By", sortable: true},
                {key: "Download", sortable: true},
            ],
            awardedTenderItems: [],
            awardedTenderFields: [
                {key: "CompanyName", sortable: true},
                {key: "compliant", sortable: true},
                {key: "Amount", sortable: true},
                {key: "Files", sortable: true},
                {key: "Message", sortable: true},
            ],
            showNotAwardedContractors: false,
            notAwardedTenderItems: [],
            notAwardedTenderFields: [
                {key: "CompanyName", sortable: true},
                {key: "Compliance", sortable: true},
                {key: "Amount", sortable: true},
                {key: "Files", sortable: true},
                {key: "Message", sortable: true},
                {key: "Action", sortable: true},
            ],

            expressOfInterestSuccess: "",
            expressOfInterestBtn: "notaccepted",
            resendSuccess: "",
            counts: {},
            subtractedDate: "",
            workSiteModalImageLink: "",
            quoteAwarded: false,

            //For Active Tab
            activeTab: "",

            //For Chat
            activeChatBoxInfo: {
                chatId: "",
                receiverBusinessDetails: {
                    id: "",
                    company_name: "",
                    owner: "",
                },
                senderBusinessDetails: {
                    id: "",
                    company_name: "",
                    owner: "",
                },
                contractorOf: "",
            },
            chatMessageInfo: {},
            chatMessages: [],
            message: "",
            latestDoc: null,
            uuids: [], //For Counting unread messages

            verifyForm: new Form({
                quote_id: "",
                rating: "",
                comment: "",
                rating_rate_fee: "",
                rating_timeliness: "",
                rating_job_satisfaction: "",
                rating_transparency: "",
            })
        };
    },
    mounted() {
        this.fetchQuote(this.$route.params.id);
        this.getCounts();
        this.getAwardedTenders();
        this.getProgress();

        //For Handling scroll message
        this.$el.querySelector("#chat-message") &&
        this.$el
            .querySelector("#chat-message")
            .addEventListener("scroll", this.handleScroll);
    },

    methods: {
        fetchQuote(id) {
            axios
                .post("api/manager/quote/getDetails", {
                    id: id,
                    load_creating_user: 1,
                    load_manager: 1,
                    load_strata_plan: 1,
                    load_user_invitation: 1,
                    load_categories: 1,
                    load_media_site_photos: 1,
                    load_media_attachments: 1,
                })
                .then((response) => {
                    //there will be no due date on workorder
                    response.data.quote.issue_date
                        ? this.dateFormat(response.data.quote, "issueDate")
                        : "";
                    response.data.quote.due_date
                        ? this.dateFormat(response.data.quote, "dueDate")
                        : "";

                    this.quote = response.data.quote;

                    //Remaining Days for due soon quote
                    if (
                        this.quote.status_parsed == "open-due-quotes" ||
                        this.quote.status_parsed == "active-due-quotes"
                    ) {
                        var dueDate = moment(response.data.quote.due_date).add(1, "days");
                        var currentDate = moment();
                        this.subtractedDate = dueDate.diff(currentDate, "days"); // 1
                    }

                    //Passed Days for due soon quote
                    if (this.quote.status_parsed == "over-due") {
                        var dueDate = moment(response.data.quote.due_date);
                        var currentDate = moment();
                        this.subtractedDate = currentDate.diff(dueDate, "days"); // 1
                    }

                    this.quote.site_access_contact = response.data.quote.site_contact
                        ? this.formatPhoneForAustraliaBySpace(
                            response.data.quote.site_contact
                        )
                        : "";

                    this.getInvitedContractors();
                    this.fetchAuditLogs();
                });
        },
        getAwardedTenders() {
            this.activeTab = "";
            axios
                .post("api/manager/quote/getDetails", {
                    id: this.$route.params.id,
                    load_awarded_tender: 1,
                    load_awarded_tender_receiving_business: 1,
                })
                .then((response) => {
                    this.awardedTenderItems = _.map(
                        response.data.quote.awarded_tenders,
                        function (awardedTender) {
                            return {
                                awardedTenderDetails: awardedTender,
                                CompanyName: awardedTender.receiving_business.company_name,
                                compliant: awardedTender.receiving_business.compliant,
                                Amount: awardedTender.amount
                                    ? "$ " + awardedTender.amount
                                    : "No Amount",
                                pivot: awardedTender,
                                business: response.data.quote.business,
                                Files: "",
                                Message: "",
                                unread_count: 0,
                            };
                        }
                    );
                    if (this.awardedTenderItems.length > 0) {
                        this.getUuidForUnreadMessageCount(this.awardedTenderItems); //Get All Uuid of of contractor related to active tabs
                        this.checkForUnreadChatOnInvitations(this.awardedTenderItems); // Check for unread chat for notifications
                    }
                });
        },
        getNotAwardedTenders() {
            axios
                .post("api/manager/quote/getDetails", {
                    id: this.$route.params.id,
                    load_not_awarded_tender: 1,
                    load_not_awarded_tender_receiving_business: 1,
                })
                .then((response) => {
                    this.notAwardedTenderItems = _.map(
                        response.data.quote.not_awarded_tenders,
                        function (notAwardedTender) {
                            return {
                                not_awarded_tender_id: notAwardedTender.id,
                                notAwardedTenderDetails: notAwardedTender,
                                CompanyName: notAwardedTender.receiving_business.company_name,
                                Compliance: "Complaint",
                                Amount: notAwardedTender.amount
                                    ? "$ " + notAwardedTender.amount
                                    : "No Amount",
                                Files: "",
                                Message: "",
                                Action: "",
                            };
                        }
                    );
                    this.showNotAwardedContractors = true;
                });
        },
        getProgress() {
            axios
                .post("api/manager/quote/getDetails", {
                    id: this.$route.params.id,
                    load_business_tenders: 1,
                    load_progress_file_receiving_business: 1,
                    load_progress: 1,
                })
                .then((response) => {
                    this.progressFileItems = _.map(
                        response.data.quote.progresses,
                        function (progress) {
                            return {
                                progressDetail: progress,
                                Progress: progress.percentage + "%",
                                Description: progress.description,
                                Date: moment(progress.created_at).format("D MMM YYYY"),
                                By:
                                    progress.marking_user.first_name +
                                    " " +
                                    progress.marking_user.last_name,
                                Download: "",
                            };
                        }
                    );
                });
        },
        confirmNotAwardedTender(not_awarded_tender_id, action_type) {
            if (action_type == "re-assign") {
                var alertMessage = "Are you sure want to re-assign this contractor?";
            } else if (action_type == "re-quote") {
                var alertMessage = "Are you sure want to send re-quote request?";
            }

            this.boxTwo = "";
            this.$bvModal
                .msgBoxConfirm(alertMessage, {
                    title: "Confirmation",
                    size: "md",
                    okVariant: "primary",
                    cancelVariant: "danger",
                    okTitle: "YES",
                    buttonSize: "md",
                    cancelTitle: "Cancel",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((response) => {
                    if (response) {
                        this.notAwardedTenderActionSubmitted(
                            not_awarded_tender_id,
                            action_type
                        );

                        this.showNotAwardedContractors = false;
                    }
                })
                .catch((err) => {
                    // An error occurred
                });
        },
        notAwardedTenderActionSubmitted(not_awarded_tender_id, action_type) {
            axios
                .post("api/manager/quote/notAwardedTenderAction", {
                    quote_id: this.$route.params.id,
                    id: not_awarded_tender_id,
                    type: action_type,
                })
                .then((response) => {
                    if (action_type == "re-assign") {
                        var alertMessage =
                            "Quote reassigned to new contractor successfully.";
                    } else if (action_type == "re-quote") {
                        var alertMessage =
                            "Re-quote request sent to contractor successfully.";
                    }

                    this.getAwardedTenders();

                    Swal.fire({
                        title: alertMessage,
                        icon: "success",
                        timer: 3000,
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                    });
                });
        },
        getInvitedContractors() {
            this.activeTab = "";
            axios
                .post("api/manager/quote/getDetails", {
                    id: this.$route.params.id,
                    load_business_invitations: 1,
                    load_business_invitations_receiving_business: 1,
                })
                .then((response) => {
                    this.invitedContractorsItems = _.map(
                        response.data.quote.business_invitations,
                        (pivot_quote_business) => {
                            return {
                                company_name:
                                pivot_quote_business.receiving_business.company_name,
                                compliant: pivot_quote_business.receiving_business.compliant,
                                status: moment(pivot_quote_business.created_at).fromNow(),
                                pivot: pivot_quote_business,
                                business: response.data.quote.business,
                                sent: "resend",
                                message: "message",
                                unread_count: 0,
                                // has_unread_message: false,
                            };
                        }
                    );

                    if (this.invitedContractorsItems.length > 0) {
                        this.getUuidForUnreadMessageCount(this.invitedContractorsItems); //Get All Uuid of of contractor related to active tabs
                        this.checkForUnreadChatOnInvitations(this.invitedContractorsItems); // Check for unread chat for notifications
                    }
                });
        },
        fetchAuditLogs(page = 1) {
            axios
                .post("api/manager/quote/fetchAuditLogs", {
                    format: "json",
                    quote_id: this.$route.params.id,
                    page,
                })
                .then((response) => {
                    if (page == 1) {
                        this.auditLogs = response.data.audit_logs;
                    } else {
                        _.forEach(response.data.audit_logs, (audit_log) =>
                            this.auditLogs.push(audit_log)
                        );
                    }
                    this.auditLogsHasMorePages = response.data.has_more_pages;
                    this.auditLogsPage = page;
                });
        },
        handleAuditLogsDownloadClicked() {
            axios({
                url: "api/manager/quote/fetchAuditLogs",
                method: "post",
                responseType: "blob",
                data: {
                    format: "pdf",
                    quote_id: this.$route.params.id,
                },
            }).then((response) => {
                let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                let fileLink = document.createElement("a");
                fileLink.href = fileURL;
                // fileLink.setAttribute('download', `Quote-Work Order Audit Logs ${this.$route.params.id}.pdf`);
                document.body.appendChild(fileLink);
                fileLink.click();
                fileLink.remove();
            });
        },
        handleQuotePdfDownloadClicked() {
            axios({
                url: "api/manager/quote/generate-pdf",
                method: "post",
                responseType: "blob",
                data: {
                    format: "pdf",
                    quote_id: this.$route.params.id,
                },
            }).then((response) => {
                var blob = new Blob([response.data], {type: "application/pdf"});
                var blobURL = URL.createObjectURL(blob);
                window.open(blobURL);
            });
        },
        handleQuotePdfDownloadClicked() {
            axios({
                url: "api/manager/quote/generate-pdf",
                method: "post",
                responseType: "blob",
                data: {
                    format: "pdf",
                    quote_id: this.$route.params.id,
                },
            }).then((response) => {
                var blob = new Blob([response.data], {type: "application/pdf"});
                var blobURL = URL.createObjectURL(blob);
                window.open(blobURL);
            });
        },
        handleInvoicePdfDownloadClicked() {
            axios({
                url: "api/manager/quote/generate-invoice-pdf",
                method: "post",
                responseType: "blob",
                data: {
                    format: "pdf",
                    quote_id: this.$route.params.id,
                },
            }).then((response) => {
                var blob = new Blob([response.data], {type: "application/pdf"});
                var blobURL = URL.createObjectURL(blob);
                window.open(blobURL);
            });
        },
        getExpressionOfInterests() {
            this.activeTab = "";
            axios
                .post("api/manager/quote/getDetails", {
                    id: this.$route.params.id,
                    load_business_interests: 1,
                    load_business_interests_sending_business: 1,
                })
                .then((response) => {
                    this.expressionOfInterest = _.map(
                        response.data.quote.business_interests,
                        function (pivot_quote_business) {
                            return {
                                company_name:
                                pivot_quote_business.sending_business.company_name,
                                compliant: pivot_quote_business.sending_business.compliant,
                                // action: moment(pivot_quote_business.created_at).fromNow(),
                                action: "",
                                // message: "message",
                                pivot: pivot_quote_business,
                            };
                        }
                    );
                });
        },
        getSubmittedTenders() {
            this.activeTab = "";
            axios
                .post("api/manager/quote/getDetails", {
                    id: this.$route.params.id,
                    load_business_tenders: 1,
                    load_business_tenders_receiving_business: 1,
                    load_business_tenders_tender_submitting_user: 1,
                })
                .then((response) => {
                    this.submittedTenders = _.map(
                        response.data.quote.business_tenders,
                        function (pivot_quote_business) {
                            return {
                                fileAttachment: pivot_quote_business.media.length,
                                company_name: pivot_quote_business.receiving_business.company_name,
                                compliant: pivot_quote_business.receiving_business.compliant,
                                amount: "$" + pivot_quote_business.amount,
                                action: "",
                                message: "message",
                                pivot_is_awarded: pivot_quote_business.is_awarded ? true : null,
                                pivot: pivot_quote_business,
                                business: response.data.quote.business,
                                quote_business_status: pivot_quote_business.status,
                                unread_count: 0,
                                // requestToEdit: pivot_quote_business.req_to_edit
                            };
                        }
                    );

                    if (this.submittedTenders.length > 0) {
                        this.getUuidForUnreadMessageCount(this.submittedTenders); //Get All Uuid of of contractor related to active tabs
                        this.checkForUnreadChatOnInvitations(this.submittedTenders); // Check for unread chat for notifications
                    }
                });
        },
        confirmRespondExpressOfInterest(submit_type, pivot_quote_business) {
            this.checkIfPermitted() && this.checkIfQuoteIsOverdue() &&
            this.$bvModal
                .msgBoxConfirm("Are you sure want to " + submit_type, {
                    title: "Confirmation",
                    size: "md",
                    okVariant: "primary",
                    cancelVariant: "danger",
                    okTitle: "YES",
                    buttonSize: "md",
                    cancelTitle: "Cancel",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    value &&
                    this.respondExpressOfInterest(submit_type, pivot_quote_business);
                })
                .catch((err) => {
                    // An error occurred
                });
        },
        respondExpressOfInterest(submit_type, pivot_quote_business) {
            axios
                .post("api/manager/quote/respondExpressOfInterest", {
                    pivot_quote_business_id: pivot_quote_business.id,
                    quote_id: this.$route.params.id,
                    submit_type: submit_type,
                })
                .then(() => {
                    if (submit_type == "accept") {
                        pivot_quote_business.status = "express_interest_accepted";
                    } else if (submit_type == "reject") {
                        pivot_quote_business.status = "express_interest_rejected";
                    }

                    this.getCounts();
                });
        },
        dateFormat(quote, date_type) {
            if (date_type == "issueDate") {
                var newDate = new Date(quote.issue_date);
            }
            if (date_type == "dueDate") {
                var newDate = new Date(quote.due_date);
            }

            var months = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ];
            var MonthName = months[newDate.getMonth()];
            var year = newDate.getFullYear();
            var date = newDate.getDate();
            var datePosted = date + " " + MonthName + " " + year;

            if (date_type == "issueDate") {
                return (quote.issue_date = datePosted);
            } else if (date_type == "dueDate") {
                return (quote.due_date = datePosted);
            }
        },
        getCounts() {
            axios
                .post("api/manager/quote/getCounts", {
                    quote_id: this.$route.params.id,
                    jobType: this.workOrder ? "work-order" : "quote",
                })
                .then((response) => {
                    this.counts = response.data;
                });
        },
        awardTender(pivot_quote_business) {
            this.checkIfPermitted() &&
            axios
                .post("api/manager/quote/awardTender", {
                    pivot_quote_business_id: pivot_quote_business.pivot.id,
                    quote_id: this.$route.params.id,
                })
                .then(() => {
                    pivot_quote_business.pivot_is_awarded = true;
                    this.quote.status_parsed = "completed";
                    this.quoteAwarded = true;
                    this.getCounts();
                });
        },
        resendInvitation(pivot_quote_business) {
            this.checkIfPermitted() && this.checkIfQuoteIsOverdue() &&
            axios
                .post("api/manager/quote/resendInvitation", {
                    quote_id: this.$route.params.id,
                    pivot_quote_business_id: pivot_quote_business.id,
                })
                .then((response) => {
                    this.resendSuccess = "The invitation has been resend successfully.";
                });
        },
        checkIfPermitted() {
            if (this.$store.state.authenticatedUserData.user.id != this.quote.manager.id) {
                Swal.fire({
                    title: "Sorry, Not Permitted.",
                    icon: "error",
                    timer: 3000,
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                });

                return false;
            }
            return true;
        },
        checkIfQuoteIsOverdue() {
            if (this.quote.status_parsed == "over-due") {
                Swal.fire({
                    title: "Sorry, This Quote has already expired.",
                    icon: "error",
                    timer: 3000,
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                });

                return false;
            }
            return true;
        },

        confirmAwardTender(pivot_quote_business) {
            this.checkIfPermitted() && this.checkIfQuoteIsOverdue() &&
            this.$bvModal
                .msgBoxConfirm("Are you sure want to award?", {
                    title: "Confirmation",
                    size: "md",
                    okVariant: "primary",
                    cancelVariant: "danger",
                    okTitle: "YES",
                    buttonSize: "md",
                    cancelTitle: "Cancel",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    value && this.awardTender(pivot_quote_business);
                })
                .catch((err) => {
                    // An error occurred
                });
        },
        handleWorkSiteImageClick(image_link) {
            this.workSiteModalImageLink = image_link;
            this.$bvModal.show("modal-work-site-image");
        },
        confirmAcceptToUpdateBidRequest(pivot_quote_business) {
            this.checkIfPermitted() && this.checkIfQuoteIsOverdue() &&
            this.$bvModal
                .msgBoxConfirm("Are you sure want to accept edit request bid?", {
                    title: "Confirmation",
                    size: "md",
                    okVariant: "primary",
                    cancelVariant: "danger",
                    okTitle: "YES",
                    buttonSize: "md",
                    cancelTitle: "Cancel",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    value && this.acceptToUpdateBidRequest(pivot_quote_business);
                })
                .catch((err) => {
                    // An error occurred
                });
        },
        acceptToUpdateBidRequest(pivot_quote_business) {
            this.checkIfQuoteIsOverdue() &&
            axios
                .post("api/manager/quote/acceptToUpdateBidRequest", {
                    pivot_quote_business_id: pivot_quote_business.pivot.id,
                })
                .then((response) => {
                    pivot_quote_business.pivot.status = "edit_bid_accepted";
                });
        },
        confirmRejectToUpdateBidRequest(pivot_quote_business) {
            this.checkIfPermitted() && this.checkIfQuoteIsOverdue() &&
            this.$bvModal
                .msgBoxConfirm("Are you sure want to reject edit request bid?", {
                    title: "Confirmation",
                    size: "md",
                    okVariant: "primary",
                    cancelVariant: "danger",
                    okTitle: "YES",
                    buttonSize: "md",
                    cancelTitle: "Cancel",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    value && this.rejectToUpdateBidRequest(pivot_quote_business);
                })
                .catch((err) => {
                    // An error occurred
                });
        },
        rejectToUpdateBidRequest(pivot_quote_business) {
            this.checkIfQuoteIsOverdue() &&
            axios
                .post("api/manager/quote/rejectToUpdateBidRequest", {
                    pivot_quote_business_id: pivot_quote_business.pivot.id,
                })
                .then((response) => {
                    pivot_quote_business.pivot.status = "edit_bid_rejected";
                });
        },

        //For Chat Application
        openChat(
            uuid,
            chat_with_business_details,
            my_business_details,
            contractor_of
        ) {
            if (this.checkIfPermitted()) {
                this.activeTab = "chat";
                this.initializeChatBoxInfo(
                    uuid,
                    chat_with_business_details,
                    my_business_details,
                    contractor_of
                );

                this.getMessageFromFireBase(uuid);

                setTimeout(() => {
                    this.scrollToBottom();
                }, 300);

                this.activeChat == "chat" && this.updateUnreadToReadMessages(uuid); //For updating unread messages to read
            }

        },
        getUuidForUnreadMessageCount(contractors) {
            var uuids = [];
            contractors.forEach((item) => {
                uuids.push(item.pivot.id);
            });
            this.uuids = uuids;
        },
        initializeChatBoxInfo(
            uuid,
            chat_with_business_details,
            my_business_details,
            contractor_of
        ) {
            this.activeChatBoxInfo.receiverBusinessDetails =
                chat_with_business_details;
            this.activeChatBoxInfo.senderBusinessDetails = my_business_details;
            this.activeChatBoxInfo.chatId = uuid;
            this.activeChatBoxInfo.contractorOf = contractor_of;
        },
        checkForUnreadChatOnInvitations(contractors) {
            console.log(contractors);
            // check unread chat messages
            let messageQuery = query(
                collection(this.$root.fireStore, "chat-message-info"),
                where("chat_id", "in", this.uuids),
                where("receiving_business_id", "==", this.quote.business.id),
                where("read", "==", false)
            );

            onSnapshot(messageQuery, (querySnapshot) => {
                var allMessages = [];
                querySnapshot.forEach((snap) => {
                    allMessages.push(snap.data());
                });

                contractors.forEach((item, index) => {
                    let sameUuid = _.filter(allMessages, ["chat_id", item.pivot.id]);
                    let countUnreadMessages = sameUuid.length;
                    contractors[index].unread_count = countUnreadMessages;
                });
            });
        },
        getMessageFromFireBase(uuid) {
            let messageQuery = query(
                collection(this.$root.fireStore, "chat-message-info"),
                where("chat_id", "==", this.activeChatBoxInfo.chatId),
                orderBy("timestamp", "desc"),
                endAt(this.latestDoc ? this.latestDoc.timestamp : 0),
                limit(10)
            );
            setTimeout(() => {
                onSnapshot(messageQuery, (querySnapshot) => {
                    let allMessages = [];
                    querySnapshot.forEach((snap) => {
                        allMessages.push(snap.data());
                    });

                    this.chatMessages = allMessages;
                    this.chatMessages.reverse();

                    setTimeout(() => {
                        this.scrollToBottom();
                        this.activeTab == "chat" && this.updateUnreadToReadMessages(uuid); //Update message to read when user is on chatbox
                    }, 2000);
                });
            }, 100);
            if (this.$el.querySelector("#chat-message").scrollTop != 0) {
                setTimeout(() => {
                    this.scrollToBottom();
                }, 2000);
            }
        },
        async updateUnreadToReadMessages(uuid) {
            let messageQuery = query(
                collection(this.$root.fireStore, "chat-message-info"),
                where(
                    "receiving_business_id",
                    "==",
                    this.activeChatBoxInfo.senderBusinessDetails.id
                ),
                where("chat_id", "==", uuid),
                where("read", "==", false)
            );
            var getDocument = await getDocs(messageQuery);
            getDocument.forEach(async (item) => {
                let document = doc(this.$root.fireStore, "chat-message-info", item.id);
                await updateDoc(document, {
                    read: true,
                });
            });
        },
        handleScroll() {
            if (this.$el.querySelector("#chat-message").scrollTop == 0) {
                this.latestDoc = this.chatMessages[0];
                this.$el
                    .querySelector("#chat-message")
                    .firstChild.setAttribute("id", "lastMessage");

                this.loadMoreMessages();

                //Scrolling to last message of pagination
                setTimeout(() => {
                    document
                        .getElementById("lastMessage")
                        .scrollIntoView({behavior: "smooth", block: "nearest"});
                }, 200);
            }
        },

        async loadMoreMessages() {
            var messageQuery = query(
                collection(this.$root.fireStore, "chat-message-info"),
                where("chat_id", "==", this.activeChatBoxInfo.chatId),
                // where("sending_business_id", "in", [
                //   this.activeChatBoxInfo.receiverBusinessDetails.id,
                //   this.activeChatBoxInfo.senderBusinessDetails.id,
                // ]),
                where("timestamp", "!=", this.latestDoc.timestamp),
                orderBy("timestamp"),
                endAt(this.latestDoc ? this.latestDoc.timestamp : 0),
                limitToLast(11)
            );

            const unsubscribe = onSnapshot(messageQuery, (querySnapshot) => {
                var moreMessages = [];
                querySnapshot.forEach((snap, index) => {
                    moreMessages.push(snap.data());
                });

                //Reversing loaded messages and pushed into chat messages
                moreMessages.reverse();
                moreMessages.forEach((message) => {
                    this.chatMessages.unshift(message);
                });
            });
        },

        async sendMessage() {
            //Sending new message to firestore collection
            this.message &&
            (await addDoc(collection(this.$root.fireStore, "chat-message-info"), {
                type: "message",
                chat_id: this.activeChatBoxInfo.chatId,
                message: this.message,
                receiving_business_id:
                this.activeChatBoxInfo.receiverBusinessDetails.id,
                receiving_business_details: _.pick(
                    this.activeChatBoxInfo.receiverBusinessDetails,
                    ["id", "company_name"]
                ),
                receiving_user_details: _.pick(
                    this.activeChatBoxInfo.receiverBusinessDetails.owner,
                    ["id", "first_name", "last_name", "email", "phone"]
                ),
                sending_business_id: this.activeChatBoxInfo.senderBusinessDetails.id,
                sending_business_details: _.pick(
                    this.activeChatBoxInfo.senderBusinessDetails,
                    ["id", "company_name"]
                ),
                sending_user_details: _.pick(
                    this.activeChatBoxInfo.senderBusinessDetails.owner,
                    ["id", "first_name", "last_name", "email", "phone"]
                ),
                quote_no: this.$route.params.id,
                timestamp: new Date(),
                read: false,
            }));

            setTimeout(() => {
                this.scrollToBottom();
            }, 200);

            //Emptying message input`
            this.message = "";
        },
        sendAttachment: function (event, file_type) {
            if (!event.target.files.length) return;
            var input = event.target.files;

            input &&
            _.forEach(input, (file) => {
                if (file_type == "image") {
                    let extension = file.name.split(".").pop();
                    if (
                        extension != "gif" &&
                        extension != "png" &&
                        extension != "bmp" &&
                        extension != "jpeg" &&
                        extension != "jpg"
                    ) {
                        Swal.fire({
                            title: "Please upload valid image.",
                            icon: "error",
                            timer: 3000,
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                        });
                        return;
                    }
                }

                let storageRef = ref(this.$root.storage, "chat-files/" + file.name);
                uploadBytes(storageRef, file).then(() => {
                    getDownloadURL(storageRef).then(async (url) => {
                        //Sending new message to firestore collection
                        await addDoc(
                            collection(this.$root.fireStore, "chat-message-info"),
                            {
                                type: file_type,
                                chat_id: this.activeChatBoxInfo.chatId,
                                file_name: file.name,
                                message: url,
                                receiving_business_id:
                                this.activeChatBoxInfo.receiverBusinessDetails.id,
                                receiving_business_details:
                                this.activeChatBoxInfo.receiverBusinessDetails,
                                receiving_user_details: _.pick(
                                    this.activeChatBoxInfo.receiverBusinessDetails.owner,
                                    [
                                        "id",
                                        "first_name",
                                        "last_name",
                                        "email",
                                        "first_name",
                                        "phone",
                                        "first_name",
                                    ]
                                ),
                                sending_business_id:
                                this.activeChatBoxInfo.senderBusinessDetails.id,
                                sending_business_details:
                                this.activeChatBoxInfo.senderBusinessDetails,
                                sending_user_details: _.pick(
                                    this.activeChatBoxInfo.senderBusinessDetails.owner,
                                    [
                                        "id",
                                        "first_name",
                                        "last_name",
                                        "email",
                                        "first_name",
                                        "phone",
                                        "first_name",
                                    ]
                                ),
                                quote_no: this.$route.params.id,
                                timestamp: new Date(),
                            }
                        );

                        setTimeout(() => {
                            this.scrollToBottom();
                        }, 3000);
                    });
                });
            });
        },
        scrollToBottom() {
            let container = this.$el.querySelector("#chat-message");
            container.scrollTop = container.scrollHeight;
        },
        momentDate: function (timestamp) {
            let date = new Date(timestamp.seconds * 1000);
            return moment(date).format("D MMM YYYY | LT");
        },
        newline() {
            this.message = `${this.message}`;
        },
        verifySubmit() {
            this.verifyForm.quote_id = this.quote?.id;
            this.verifyForm.post("api/manager/quote/verifySubmit").then((response) => {
                this.$bvModal.hide('verify');
            });
        }
    },
};
</script>

<style scoped>
.modal-backdrop {
    background-color: #00000094;
}

.section-description p {
    /* display: inline-block; */
    line-height: 20px;
}

.btn:focus,
.btn.focus {
    box-shadow: none;
}

.manager-quote-tab li.nav-item {
    margin-right: 25px;
}


.modal-header {
    display: flex !important;
}

.job-detail ul li span.title {
    font-weight: 600;
}

.job-detail ul li span.sub-title {
    margin-left: 10px;
}


.deatil-content ul li {
    display: flex;
    color: #828282;
}


.tab-icon {
    margin-right: 5px;
}

/** tabs **/
@media screen and (max-width: 991px) {
    .manager-quote-tab ul li a {
        text-overflow: ellipsis;
        max-width: 175px;
        overflow: hidden;
        white-space: nowrap;
    }
}

@media screen and (min-width: 992px) {
    .manager-quote-tab ul li a {
        min-width: 125px;

    }
}

@media screen and (max-width: 767px) {
    .tab-icon-title {
        display: none;
    }
}

.verify p.sub-title {
    color: #767B80;
    font-size: 12px;
    line-height: 15px;
    font-weight: 500;
}

.rate-content p {
    margin-bottom: 0;
    font-weight: 400;
    line-height: 15px;
    font-size: 12px;
}

.rate-content .star {
    border-radius: 0;
    cursor: pointer;
}

.rate-content .star .b-rating-icon svg {
    transform: scale(1);
    transition: scale 200ms linear;
    background: red;
}

.rate-content .star .b-rating-icon svg:hover {
    transform: scale(1.2);
    transition: scale 200ms linear;
}

.rating-val #rate,
.rating-val #time,
.rating-val #job,
.rating-val #transparent {
    border-radius: 0;
    width: 50%;
    background: none;
}

.rating-val label {
    width: 30%;
    min-width: 115px;
}

.b-rating-star b {
    font-weight: 400;
    margin-top: 5px;
}

/* .b-rating-icon {
    display: inline-flex;
    transition: all .15s ease-in-out;
    color: red !important;
}

.b-rating:not(.disabled):not(.readonly) .b-rating-star:hover .b-rating-icon, .b-rating:not(.disabled):not(.readonly):focus:not(:hover) .b-rating-star.focused .b-rating-icon {
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
} */
</style>
